import axiosAPI from 'axios';

const axios = axiosAPI.create({
    baseURL: process.env.REACT_APP_99GIFT_ENDPOINT || 'https://api2.99gift.in/api/v6/',
});

export { axios };
